
import "../styles/AdminInterface.css"
import React, { useState } from 'react';
import { TextField, Button, Divider, Typography, TableContainer, TableHead, TableRow, Paper, TableBody, Table, TableCell, Select,Menu, MenuItem, Dialog,DialogActions,DialogContent,DialogContentText,DialogTitle } from "@material-ui/core"



const Popup=({open,text,reponse,handleClose})=> {
  // State to control the open/close state of the dialog

  // Function to handle opening the dialog
  

  // Function to handle closing the dialog
//   const handleClose = () => {
//     setOpen(false);
//   };

  return (

      <Dialog open={open} onClose={handleClose}>

        {/* <DialogTitle >Popup Title</DialogTitle> */}
        <DialogContent>
          {text}
        </DialogContent>
        <DialogActions >
          {/* <Button onClick={handleClose} color="primary"> */}
          <Button variant="contained" className="admin-button" onClick={()=>handleClose("Retour")}  >
            Retour
          </Button>
          <Button variant="contained" className="admin-button" onClick={()=>handleClose(reponse)} color="primary">
            Valider
          </Button  >
        </DialogActions>
      </Dialog>
  );
}

export default Popup;
